import React from "react";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { reserveCar } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { MODAL_RESERVE_TERMS } from "../../../../utils/modalConstants";
import FinanceQuotes from "../../common/FinanceQuotes";
import DisclaimerContainer from "../../common/disclaimer/DisclaimerContainer";
import ReservePanel from "./ReservePanel";
import useReserve from "../../../../hooks/buy/useReserve";
import { Container } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Styles from "./styles/Reserve";
import IconCarFront from "../../../../svg/lexus/car-front.svg";
import IconPriceAlt from "../../../../svg/lexus/price-alt.svg";
import IconLock from "../../../../../../../common-deprecated/svg/lexus/lock.svg";
import IconCheck from "../../../../../../../common-deprecated/svg/lexus/check.svg";
import IconFile from "../../../../../../../common-deprecated/svg/lexus/file.svg";
import IconUser from "../../../../../../../common-deprecated/svg/lexus/user.svg";
import { trackCtaCheckout } from "../../../../utils/tracking";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const getReservationIcon = (iconType: string): JSX.Element | null => {
    switch (iconType) {
        case "lock":
            return <IconLock />;
        case "car":
            return <IconCarFront />;
        case "file-alt":
            return <IconFile />;
        case "user":
            return <IconUser />;
        case "price-alt":
            return <IconPriceAlt />;
        case "ok":
            return <IconCheck />;
        default:
            return null;
    }
};

const ReserveView = (): JSX.Element => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const { labels, enableTermsConditions } = useReserve();
    const quoteTable = useBnbSelector((state) => state.finance.info.disclaimer?.table);

    const [reserveDescriptionLabel, reserveDescriptionMonthlyLabel] = useBnbOptionalLabel([
        "reserveDescription",
        "reserveDescriptionMonthly",
    ]);
    const description =
        financeOption === "monthly" && reserveDescriptionMonthlyLabel
            ? "reserveDescriptionMonthly"
            : reserveDescriptionLabel
              ? "reserveDescription"
              : null;

    const onReserveCar = (): void => {
        trackCtaCheckout(NavStep.Reserve, "online-retailing-checkout-reservation");
        dispatch(reserveCar());
    };
    const openConditionsModal = (event: React.MouseEvent): void => {
        event.preventDefault();
        dispatch(showModal({ type: MODAL_RESERVE_TERMS }));
    };

    return (
        <>
            <Styles.Wrapper pb={{ xs: 0, md: 0, lg: "48px" }} dark>
                <Container>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, lg: 1 / 2 }}>
                            <Styles.Title>
                                <BnbLabel
                                    label={financeOption === "cash" ? "reserveTitle" : "reserveTitleMonthly"}
                                    fallbackLabel="reserveTitle"
                                />
                            </Styles.Title>

                            {description && (
                                <Styles.Description>
                                    <BnbLabel label={description} useHTML />
                                </Styles.Description>
                            )}

                            <Styles.ActionList>
                                {labels.map((item) => (
                                    <Styles.ActionItem key={item.icon}>
                                        {getReservationIcon(item.icon)}
                                        {item.extraInfo || item.extraText ? (
                                            <span>
                                                <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                                <Popover showOnClick content={item.extraInfo} />
                                                <span dangerouslySetInnerHTML={{ __html: item.extraText || "" }} />
                                            </span>
                                        ) : (
                                            <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                        )}
                                    </Styles.ActionItem>
                                ))}
                            </Styles.ActionList>

                            {enableTermsConditions && (
                                <Styles.Link onClick={openConditionsModal}>
                                    <BnbLabel
                                        label={
                                            financeOption === "cash"
                                                ? "reserveTermsConditionsLink"
                                                : "reserveTermsConditionsLinkMonthly"
                                        }
                                        fallbackLabel="reserveTermsConditionsLink"
                                    />
                                </Styles.Link>
                            )}
                        </Flex.Col>

                        <Styles.Sidebar width={{ _: 1, lg: 1 / 2 }}>
                            <ReservePanel reserveCar={onReserveCar} />
                        </Styles.Sidebar>
                    </Flex.Row>
                </Container>
            </Styles.Wrapper>

            {financeOption === "monthly" && quoteTable && quoteTable.length && (
                <Styles.Wrapper>
                    <Container>
                        <FinanceQuotes />
                    </Container>
                </Styles.Wrapper>
            )}

            <Styles.Wrapper dark>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer />
                </Container>
            </Styles.Wrapper>
        </>
    );
};

export default ReserveView;
